export default {
  init() {
    $('html, body').animate({scrollTop: 0}, 'fast');

    $('.slider').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.slider-read-inside').slick({
      infinite: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });

    $('.slider-image').slick({
      infinite: true,
      arrows: true,
      slidesToShow: 7,
      slidesToScroll: 7,
    });

    // Go to top / anchor
    let last_anchor = null;
    const getTop = el => el.offsetTop + (el.offsetParent && getTop(el.offsetParent));

    $('.arrow-navigate').on('click', function() {
      if($(this).find('svg').hasClass('rotate-180')) {
        $('html, body').animate({scrollTop: 0}, 'fast');
      } else {
        let anchor = $('.content section[id], .content article[id], .content div[id], footer.footer-container');

        if(last_anchor !== null && last_anchor !== anchor.length - 1) {
          last_anchor = last_anchor + 1;
        } else {
          last_anchor = 0;
        }

        $('html, body').animate({scrollTop: getTop(anchor[last_anchor]) - 50}, 'fast');
      }
    });

    const footerRatio = 0;

    const footerOptions = {
      'root': null,
      'rootMargin': '0px',
      'threshold': footerRatio,
    };

    const footerIntersect = function (entries) {
      entries.forEach(function (entry) {
        if (entry.target.clientHeight > window.innerHeight || entry.intersectionRatio > footerRatio) {
          $('.arrow-navigate').find('svg').addClass('transform rotate-180');
        } else {
          $('.arrow-navigate').find('svg').removeClass('transform rotate-180');
        }
      });
    }

    const footerObserver = new IntersectionObserver(footerIntersect, footerOptions);
    document.querySelectorAll('.footer-container').forEach(function (r) {
      footerObserver.observe(r);
    });

    $('#hamburger-toggle').on('click', function() {
      $('#hamburger-toggle').toggleClass('is-active');
      $('#nav-primary').toggleClass('is-active');
      $('body').toggleClass('overflow-hidden');

      if($('#nav-primary').hasClass('nav-enter')) {
        $('#nav-primary').removeClass('nav-enter').addClass('nav-leave');

      } else {
        $('#nav-primary').addClass('nav-enter').removeClass('nav-leave');
      }
    });

    $('#nav-primary .menu-item a').on('click', function() {
      $('#hamburger-toggle').toggleClass('is-active');
      $('#nav-primary').toggleClass('is-active');
      $('body').toggleClass('overflow-hidden');

      if($('#nav-primary').hasClass('nav-enter')) {
        $('#nav-primary').removeClass('nav-enter').addClass('nav-leave');

      } else {
        $('#nav-primary').addClass('nav-enter').removeClass('nav-leave');
      }
    });


    if(window.matchMedia('(max-width: 640px)').matches) {
      if($('.toggle-menu').length === 0) {
        $('.menu-item-has-children > a').wrap('<div class="link-has-children flex justify-between items-center"></div>');
        $('.menu-item-has-children > .link-has-children').append('<svg xmlns="http://www.w3.org/2000/svg" class="toggle-menu z-10 cursor-pointer h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"> <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" /> </svg>');

        $('.toggle-menu').on('click', function(e) {
          e.preventDefault();
          $(this).parent().parent().find('.sub-menu').slideToggle();
        })
      }
    }

    if(window.matchMedia('(max-width: 768px)').matches) {
      if($('.slider-read-inside').length > 0) {
        $('.slider-read-inside').prev().addClass('hidden md:block');
        $('.slider-read-inside').parent().parent().find('h2.has-text-align-center').addClass('hidden md:block');
      }
    }

    if($('.block-content-text-image').length > 0) {
      $('.block-content-text-image').each(function() {
        if($(this).find('.wp-block-column:first-of-type .wp-block-image').length > 0) {
          $(this).find('.wp-block-columns').addClass('flex-col-reverse lg:flex-row');
        }
      });
    }

    if($('.block-content-text-image-see-more').length > 0) {

      if(window.matchMedia('(min-width: 1024px)').matches) {
        $('.block-content-text-image-see-more .wp-block-column:first-of-type').each(function() {
          $(this).find('p').last().addClass('text-square');

          let allText = $(this).find('> *').text()
            , numberCharGlobal = allText.length
            // , numberWordsGlobal = allText.replace( /[^\w ]/g, '' ).split( /\s+/ ).length
            ;

          const limitChars = 800;
          let limitCharsUnder = (numberCharGlobal / 2);
          console.log(numberCharGlobal);

          if($(this).parent().find('.wp-block-image').length > 0 && numberCharGlobal > 1500 && numberCharGlobal < 5000) {
            limitCharsUnder = (numberCharGlobal / 2) + (numberCharGlobal / 6);
          }

          if($(this).parent().find('.wp-block-image').length > 0 && numberCharGlobal > 5000) {
            limitCharsUnder = (numberCharGlobal / 2) + (numberCharGlobal / 20);
          }

          if(numberCharGlobal < 1500) {
            limitCharsUnder = limitChars + 200;
          }

          let numberChars = 0;
          $(this).find('> *').each(function() {

            if(numberChars >= limitChars) {
              if($(this).parent('.wp-block-column').find('.see-more-toggle').length === 0) {
                if(document.documentElement.lang === 'en-US') {
                  $(this).parent('.wp-block-column').append('<div class="see-more-toggle"><a href="#">Read more</a></div>');
                } else {
                  $(this).parent('.wp-block-column').append('<div class="see-more-toggle"><a href="#">Lire la suite</a></div>');
                }
              }

              if(!$(this).hasClass('see-more-toggle')) {
                if(numberChars >= limitCharsUnder) {
                  $(this).parent('.wp-block-column').parent().find('.wp-block-column:last-of-type').append($(this).clone());
                } else {
                  $(this).parent('.wp-block-column').append($(this).clone());
                }
                $(this).remove();
              }
            }

            let txt = $(this).text()
            , charCount = txt.length
            // , wordCount = txt.replace( /[^\w ]/g, '' ).split( /\s+/ ).length
            ;

              numberChars += charCount;
          });
        });

        $('.see-more-toggle a').on('click', function(e) {
          e.preventDefault();
          $(this).parent().parent().parent().find('.wp-block-column:last-of-type *, .see-more-toggle ~ *').fadeIn();
          $(this).remove();
        });
      } else {
        $('.block-content-text-image-see-more .wp-block-column:first-of-type').each(function() {
          $(this).find('p').last().addClass('text-square');

          const limitChars = 800;

          let numberChars = 0;
          $(this).find('> *').each(function() {

            if(numberChars >= limitChars) {
              if($(this).parent('.wp-block-column').find('.see-more-toggle').length === 0) {
                $(this).parent('.wp-block-column').append('<div class="see-more-toggle mb-6"><a href="#">Lire la suite</a></div>');
              }

              if(!$(this).hasClass('see-more-toggle')) {
                $(this).parent('.wp-block-column').append($(this).clone());
                $(this).remove();
              }
            }

            let txt = $(this).text()
            , charCount = txt.length
            // , wordCount = txt.replace( /[^\w ]/g, '' ).split( /\s+/ ).length
            ;

              numberChars += charCount;
          });
        });

        $('.see-more-toggle a').on('click', function(e) {
          e.preventDefault();
          $(this).parent().parent().parent().find('.see-more-toggle ~ *').fadeIn();
          $(this).remove();
        });
      }
    }

    /// Animations à l'apparition
    /// ============================
    const ratio = 0.2;

    const options = {
      'root': null,
      'rootMargin': '0px',
      'threshold': ratio,
    };

    const handleIntersect = function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.target.clientHeight > window.innerHeight || entry.intersectionRatio > ratio) {
          entry.target.classList.remove('ewill_reveal');
          observer.unobserve(entry.target);
        }
      });
    }

    const observer = new IntersectionObserver(handleIntersect, options);
    document.querySelectorAll('.ewill_reveal').forEach(function (r) {
      observer.observe(r);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js